import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import AddressInput from "./AddressInput/AddressInput";
import { getDistricts } from "../../../stores/address/address.action";

const ChooseAddress = ({ data, valid, onchange, refInput, isRenewal }) => {
  const dispatch = useDispatch();
  const { cities } = useSelector(state => state.address);
  const [districts, setDistricts] = useState(null);

  const refCity = useRef();
  const refDistrict = useRef();

  useEffect(() => {
    if (!isRenewal) {
      if (data.city.code) {
        getDataDistricts(data.city.code, refInput)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.city, isRenewal]);

  const getDataDistricts = (city, refInput) => {
    dispatch(getDistricts({ city: city }, (value) => {
      setDistricts(value);
      refInput && refInput.current.openModal();
    }));
  };

  const onCityChange = (value) => {
    setDistricts(null);
    onchange && onchange({ city: value, district: '' }, refDistrict);
  };

  const onDistrictChange = (value) => {
    onchange && onchange({ city: data.city, district: value });
  };

  return (
    <div style={{ width: '100%' }}>
      <AddressInput
        ref={refCity}
        style={{ marginBottom: 16 }}
        title={'Chọn tỉnh thành'}
        placeholder={'Tỉnh thành'}
        selectedValue={data.city}
        error={!valid.isValidCity}
        data={cities ? cities : []}
        disabled={!cities}
        onValueChange={onCityChange}
        require
      >
      </AddressInput>

      {
        !isRenewal && <Fragment>
          <AddressInput
            ref={refDistrict}
            style={{ marginBottom: 16 }}
            title={'Chọn phường/xã'}
            placeholder={'Phường/xã'}
            selectedValue={data.district}
            error={!valid.isValidDistrict}
            data={districts ? districts : []}
            disabled={!data.city || !districts}
            onValueChange={onDistrictChange}
            require
          >
          </AddressInput>
        </Fragment>
      }

    </div>
  )
};

export default React.memo(ChooseAddress);